import * as React from 'react';
import { FC } from 'react';
import { TypographyElement, TypographyElementProps } from './styled';

export interface TypographyProps extends TypographyElementProps {
    id?: string,
    block?: boolean,
    children: any,
    className?: string,
    style?: React.CSSProperties,
    onClick?: React.MouseEventHandler<HTMLDivElement>,
}

const Typography: FC<TypographyProps> = ({
    id,
    block,
    size,
    children,
    className,
    style,
    onClick,
}) => {
    return <TypographyElement id={id} style={{whiteSpace: 'pre-line', ...style}} size={size} block={block} className={className} onClick={onClick}>{children}</TypographyElement>;
}

export default Typography;